<template>
  <div class="property-list">
    <div v-for="(item, index) in items" :key="index" class="property-item">
      <span class="property-label">{{ item.label }}</span>
      <span class="property-value">
        <component v-if="item.component" :is="item.component" v-bind="item.componentProps" />
        <template v-else>{{ item.value }}</template>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue';

export interface PropertyItem {
  label: string;
  value?: string | number;
  component?: Component;
  componentProps?: Record<string, unknown>;
}

interface Props {
  items: PropertyItem[];
}

defineProps<Props>();
</script>

<style scoped>
.property-list {
  display: flex;
  flex-direction: column;
}

.property-item {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 0.6rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.property-item:last-child {
  border-bottom: none;
}

.property-label {
  font-size: 13px;
  color: #475467;
  flex-shrink: 0;
  margin-right: 1rem;
}

.property-value {
  font-size: 13px;
  font-weight: 500;
  text-align: right;
}
</style>
